import React, { useEffect, useState } from "react";
import { Form, Row, Col, } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchStandardSection,
  updateClassandsection,
} from "../../store/slices/getstandardsection";
import { fetchSection } from "../../store/slices/classandsection";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-hot-toast";
import { FiHome, FiChevronRight } from "react-icons/fi";
import { Link } from "react-router-dom";

export default function AddClassandSection() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  const { classsectionList = [], loading } = useSelector(
    (state) => state.classsection || {}
  );

  const { sections = [] } = useSelector((state) => state.classandsection || {});

  const [formData, setFormData] = useState({
    standardId: "",
    attendanceType: "",
  });

  const [selectedSections, setSelectedSections] = useState([]);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    dispatch(fetchSection());
  }, [dispatch]);

  useEffect(() => {
    if (!id) return;

    dispatch(fetchStandardSection({ id }))
      .unwrap()
      .then((res) => {
        const matched = res?.data?.[0];
        if (!matched) return;

        setFormData({
          standardId: matched.standardId?._id || "",
          attendanceType: matched.attendanceType || "",
        });

        if (matched?.sectionId?.length) {
          const ids = matched.sectionId.map((sec) => sec._id);
          setSelectedSections(ids);
        }
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
          err?.message ||
          "Failed to fetch class & section"
        );
      });
  }, [id, dispatch]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "standardId") {
      const selected = classsectionList.find(
        (item) => item.standardId._id === value
      );

      setFormData({
        standardId: value,
        attendanceType: selected?.attendanceType || "",
      });

      setSelectedSections([]);
      setErrors({});
      return;
    }

    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleCheckboxChange = (sectionId) => {
    setSelectedSections((prev) =>
      prev.includes(sectionId)
        ? prev.filter((id) => id !== sectionId)
        : [...prev, sectionId]
    );

    setErrors((prev) => ({ ...prev, sectionIds: "" }));
  };

  const validate = () => {
    let temp = {};

    if (!formData.standardId) temp.standardId = "Please select standard";

    if (!formData.attendanceType)
      temp.attendanceType = "Please attendance type";

    if (!selectedSections.length)
      temp.sectionIds = "Please select at least one section";

    setErrors(temp);
    return Object.keys(temp).length === 0;
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validate()) return;

    const payload = {
      id,
      standardId: formData.standardId,
      attendanceType: formData.attendanceType,
      sectionIds: selectedSections, //  IDs
    };

    dispatch(updateClassandsection(payload))
      .unwrap()
      .then(() => {
        toast.success("Class & Section updated successfully");
        navigate("/institute/classandsection");
      })
      .catch(() => {
        toast.error("Failed to update Class & Section");
      });
  };

  /* ---------------- UI ---------------- */
  return (
    <>
      <div className="page-header">

        <div className="breadcrumb-section">

          <div className="breadcrumb-left">
            <div className="home-icon">
              <Link to="/institute/home"><FiHome style={{ color: "white", marginTop: "-4px" }} /></Link>
            </div>

            <FiChevronRight className="separator" />
            <Link to="/institute/classandsection">Class and Sections</Link>

            <FiChevronRight className="separator" />

            <span className="active">Edit Class and Sections</span>
          </div>


        </div>

      </div>
      <div className="acs-card">
        <Form onSubmit={handleSubmit}>
          <Row className="g-3">
            {/* Standard */}
            <Col lg={3} md={4} sm={12}>
              <Form.Group>
                <Form.Label>Standard</Form.Label>
                <Form.Select
                  name="standardId"
                  value={formData.standardId}
                  onChange={handleChange}
                >
                  <option value="">Select Standard</option>
                  {classsectionList.map((item) => (
                    <option
                      key={item.standardId._id}
                      value={item.standardId._id}
                    >
                      {item.standardId.name}
                    </option>
                  ))}
                </Form.Select>
                {errors.standardId && (
                  <small className="text-danger">{errors.standardId}</small>
                )}
              </Form.Group>
            </Col>
            <Col lg={3} md={4} sm={12}>
              <Form.Group>
                <Form.Label>Attendance Type</Form.Label>
                <Form.Select
                  name="attendanceType"
                  value={formData.attendanceType}
                  onChange={handleChange}
                >

                  <option value="">Select Attendance Type</option>
                  <option value="1">Once</option>
                </Form.Select>
                {errors.attendanceType && (
                  <small className="text-danger">{errors.attendanceType}</small>
                )}
              </Form.Group>
            </Col>


            <Col md={12} lg={6} sm={12}>
              <Form.Label>Sections</Form.Label>

              <div className="acs-checkbox-grid">
                {sections.map((sec) => (
                  <label key={sec._id} className="acs-checkbox-item">
                    <input
                      type="checkbox"
                      checked={selectedSections.includes(sec._id)}
                      onChange={() => handleCheckboxChange(sec._id)}
                    />
                    <span>{sec.name}</span>
                  </label>
                ))}
              </div>

              {errors.sectionIds && (
                <small className="text-danger d-block mt-2">
                  {errors.sectionIds}
                </small>
              )}
            </Col>
          </Row>


          <div className="acs-actions mt-5">
            <button
              className="btn-cancel"

              type="button"
              onClick={() => navigate(-1)}
            >
              Cancel
            </button>
            <button type="submit" className="btn-submit" disabled={loading}>
              {id ? "Update" : "Submit"}
            </button>
          </div>
        </Form>

      </div>
    </>
  );
}
